import {
  BaseClass,
  GraphComponent,
  IAnimation,
  Matrix,
  MatrixOrder,
  TimeSpan
} from '@yfiles/yfiles';

export class ProjectionAnimation extends BaseClass(IAnimation) {
  constructor(
    private graphComponent: GraphComponent,
    private fromRotation: number,
    private toRotation: number,
    private fromInclination: number,
    private toInclination: number,
    private updateNodeZOrder: () => void,
    private direction: 1 | -1
  ) {
    super();
  }

  cleanUp(): void {
    // NOP
  }
  initialize(): void {
    // NOP
  }

  animate(time: number): void {
    let currentRotation: number;
    if (this.direction === 1) {
      currentRotation = (1 - time) * this.fromRotation + time * this.toRotation;
    } else {
      currentRotation = this.toRotation + (1 - time) * (this.fromRotation - this.toRotation);
    }

    const currentInclination = (1 - time) * this.fromInclination + time * this.toInclination;

    const rotationMatrix = Matrix.createRotateInstance(currentRotation);
    const inclinationMatrix = new Matrix(1, 0, 0, Math.sin(currentInclination), 0, 0);
    rotationMatrix.multiply(inclinationMatrix, MatrixOrder.APPEND);

    this.graphComponent.projection = rotationMatrix;
    this.updateNodeZOrder();
  }

  get preferredDuration(): TimeSpan {
    return TimeSpan.fromMilliseconds(1000);
  }
}
